import React from 'react';
import './Beneficios.scss';

const items = [
	{ icon: 'fa-credit-card', title: '6 cuotas sin interés', text: 'Con todas las tarjetas' },
	{ icon: 'fa-truck', title: 'Envíos rápidos', text: 'Cobertura en toda la zona' },
	{ icon: 'fa-shopping-bag', title: 'Retiro en sucursal', text: '5 sucursales para vos' },
	{ icon: 'fa-comments', title: 'Asesoramiento', text: 'Por WhatsApp y en local' },
];

const Beneficios = () => (
	<section className="beneficios">
		<div className="container">
			<div className="row">
				{items.map((item) => (
					<div key={item.title} className="col-6 col-md-3 beneficios__col">
						<div className="beneficios__item">
							<i className={`fa ${item.icon}`} aria-hidden="true"></i>
							<div>
								<div className="beneficios__title">{item.title}</div>
								<div className="beneficios__text">{item.text}</div>
							</div>
						</div>
					</div>
				))}
			</div>
		</div>
	</section>
);

export default Beneficios;
